import Reveal from "./Reveal";
import { useLang } from "@/i18n";

export default function Testimonials() {
  const { t } = useLang();

  return (
    <section id="stories" className="border-t border-line py-24 lg:py-32">
      <div className="mx-auto max-w-[1320px] px-5 sm:px-8">
        <Reveal>
          <p className="font-mono flex items-center gap-3 text-[11px] font-bold tracking-[0.25em] text-obsidian/60">
            <span className="h-2 w-2 rotate-45 bg-brand" />
            {t.stories.eyebrow}
          </p>
          <h2 className="font-display font-expanded mt-5 max-w-2xl text-3xl font-black uppercase tracking-tight text-obsidian sm:text-4xl lg:text-5xl">
            {t.stories.title}
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-3">
          {t.stories.items.map((s, i) => (
            <Reveal key={i} delay={i * 0.12}>
              <div
                data-testid={`story-card-${i + 1}`}
                className="group flex h-full flex-col rounded-2xl border border-line bg-white p-8 transition-transform duration-300 hover:-translate-y-1.5"
              >
                <p className="font-display text-6xl font-black leading-none text-brand">&rdquo;</p>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-obsidian/75 sm:text-base">{s.quote}</p>
                <div className="mt-8 flex items-center gap-3 border-t border-line pt-5">
                  <span className="h-2 w-2 rotate-45 bg-brand" />
                  <p className="font-mono text-[11px] font-bold uppercase tracking-[0.15em] text-obsidian/60">{s.role}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
